<template>
  <div v-loading="loading" element-loading-spinner="el-icon-loading">
    <div class="mine-course-menu">
      <div>
        <a v-for=" (item,i) in ['不限','学习中','已完成']"
           @click="changeType(i)"
           :class="typeIndex === i ? 'active' : ''">
          {{ item }}
        </a>
      </div>
      <el-card class="box-card" v-if="this.$route.query.title">
        <div style="display: flex; flex: 1;">
          <div @mouseenter="showTip = true" @mouseleave="showTip = false" class="card-avatar-border">
            <img :src="circleUrl" width="92" height="92" style="object-fit: cover" :onerror="failCircleUrl">
          </div>
          <div style="font-size: 14px; padding-left: 16px;">
            <p><strong>姓名:{{ this.userName }}</strong></p>
            <p><strong>身份证:{{ this.idnum }}</strong></p>
          </div>
        </div>
      </el-card>
      <div @mouseenter="showTip = true" @mouseleave="showTip = false" class="avatar-border" v-else>
        <img :src="circleUrl" width="92" height="92" style="object-fit: cover" :onerror="failCircleUrl">
      </div>
      <div style="display: flex;justify-items: center;align-items: center;">
        <span style="width: 120px; ">总学时：{{ totalHour }}</span>
        <span style="width: 120px">已完成：{{ endHour }}</span>
        <span style="width: 100px">总课程：{{ totalCourse }}</span>
      </div>

    </div>
    <div v-if="pageInfo.total>0">
      <div v-for="item in courseList" :key="item.id" class="mine-course-item">
        <a @click="getCourse(item)"><img :src="item.image" width="160" height="120"></a>
        <div class="mine-course-detail">
          <a class="mine-course-title" @click="getCourse(item)">{{ item.name }}</a>
          <div style="display: flex;margin: 4px 0px">
            <span style="line-height: 24px;margin-right: 20px">已学</span>
            <div style="width: 690px">
              <el-progress :percentage="item.process"></el-progress>
            </div>
          </div>
          <div style="display: flex;justify-items: center;">
            <span style="margin-right: 20px; width: 80px;">学时 {{ item.hours }}</span>
            <span style="margin-right: 20px; width: 80px;">问答 {{ item.questionCount || 0 }}</span>
            <span style="margin-right: 20px; width: 80px;">评论 {{ item.commentCount || 0 }}</span>
            <!--<span style="margin-right: 20px; width: 100px;">价格 {{item.price}}元</span>-->
            <el-button type="primary" round style="position: absolute;right: 0px;top: 68px;" @click="getCourse(item)">
              进入课程
            </el-button>
          </div>
        </div>
      </div>
    </div>
    <img src="@/assets/img/none.png" style="margin-left: 265px;width: 400px;height: 400px;" v-else>
    <!--页码组件-->
    <div style="width: 930px;display: flex;justify-content: center;margin-top: 15px">
      <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="pageInfo.page"
          :page-size.sync="pageInfo.size"
          :page-sizes="[5, 15, 30]"
          layout="prev, pager, next,sizes,total"
          :total="pageInfo.total">
      </el-pagination>
    </div>
  </div>
</template>

<script>
import {getUserCourse, getUserCourseCount} from "@/api/userCourse";

export default {
  name: "Course",
  data() {
    return {
      loading: false,
      endHour: 0,
      totalHour: 0,
      totalCourse: 0,
      status: '',
      typeIndex: 0,
      courseList: [],
      defaultCircleUrl: require('@/assets/img/defaultAvatar.png'),
      failCircleUrl: 'this.src="' + require('@/assets/img/failAvatar.png') + '"' + ';this.onerror=null;',
      userName: '',
      idnum: '',
      userId: '',
      circleUrl: '',
      pageInfo: {
        page: 1,
        size: 5,
        total: 0,
      },
      examno: '',  // 准考证号
    }
  },
  watch: {
    status: function () {
      this.pageInfo.page = 1;
      this.pageInfo.size = 5;
      this.typeIndex = 0;
      this.getCourseList();
    }
  },
  methods: {
    changeType(index) {
      if (this.typeIndex !== index) {
        this.typeIndex = index;
        this.pageInfo.page = 1;
        this.getCourseList();
      }
    },
    async getCourseList() {
      this.loading = true;
      const params = {
        courseType: this.status == 'All' ? '' : this.status,
        status: this.typeIndex == '0' ? '' : (this.typeIndex == '1' ? 'N' : 'Y'),
        page: this.pageInfo.page,
        size: this.pageInfo.size,
        examno: this.examno,
      };
      const {content} = await getUserCourse(params)
      // const {content} = await this.$http.post('/business/web/userCourse/queryUserCourse',params);
      this.courseList = content.records;
      this.pageInfo.total = content.total;
      this.loading = false;
    },
    getCourse(course) {
      switch (course.courseType) {
        case "O":
          this.$router.push('/home/trainDetail/' + course.id);
          break;
        case "C":
          this.$router.push('/home/eduDetail/' + course.id);
          break;
      }
    },
    async getUserCourseCount() {
      // const {content} = await this.$http.get("/business/web/userCourse/queryUserCourseCount")
      const {content} = await getUserCourseCount({examno: this.examno})
      if (content.length > 0) {
        let a = content.filter(item => item.status == "Y").map(item => item.hours)
        this.endHour = eval(a.join("+")) == undefined ? 0 : eval(a.join("+"));
        this.totalHour = eval(content.map(item => item.hours).join('+'));
        this.totalCourse = content.length;
      }
    },
    //选择每页显示条数
    handleSizeChange(val) {
      this.pageInfo.size = val;
      this.getCourseList();

    },
    //选择第几页
    handleCurrentChange(val) {
      this.pageInfo.page = val;
      this.getCourseList();
    },
  },
  created() {
    const userInfo = this.$store.state.userInfo;
    this.idnum = JSON.parse(localStorage.getItem(LOCAL_KEY_USER_INFO)).LOCAL_KEY_USER_INFO.idnum
    this.idnum = this.idnum.replace(/(\w{6})\w*(\w{4})/, '$1******$2')
    if (userInfo) {
      this.userName = userInfo.name;
      this.userId = userInfo.id;
      this.circleUrl = !userInfo.headImg ? this.defaultCircleUrl : userInfo.headImg;
    }
  },
  mounted() {
    this.examno = this.$store.state.userInfo.examno
    this.getUserCourseCount();
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.status = to.params.status;
    })
  },
  beforeRouteUpdate(to, from, next) {
    this.status = to.params.status;
    next();
  }
}
</script>

<style lang="scss" scoped>
a {
  cursor: pointer;
}

.box-card {
  position: relative;
  top: -80px;
  /*left: 30%;*/
  height: 110px;
  flex: 2;
  margin-right: 10px;

  /deep/ .el-card__body {
    padding: 8px;
  }
}

.card-avatar-border {
  //position: absolute;
  //left: 20%;
  //transform: translateX(-50%);
  //top: 5px;
  height: 92px;
  width: 92px;
  //overflow: hidden;
  border-radius: 50px;
  border: 4px solid #d9dde1;
  text-align: center;
  img {
    border-radius: 50px;
  }
}

.avatar-border{
  position: absolute ;
  left: 50%;
  transform: translateX(-50%);
  top: -64px;
  height: 92px;
  width: 92px;
  overflow:hidden;
  border-radius: 50px;
  border: 4px solid #d9dde1;
  text-align: center;
}

.mine-course-menu {
  border-bottom: 1px solid #d9dde1;
  height: 40px;
  display: flex;
  justify-content: space-between;
}

.mine-course-menu a {
  font-size: 16px;
  color: #545c63;
  margin-right: 50px;
  height: 40px;
  line-height: 40px;
  text-decoration: none;
  display: inline-block;
  &:last-child {
    margin-right: 20px;
  }
}

.mine-course-menu a:hover {
  color: #409EFF;
  border-bottom: 2px solid #409EFF;
}

.mine-course-menu .active {
  color: #409EFF;
  border-bottom: 2px solid #409EFF;
}

.mine-course-item {
  margin-top: 28px;
  /*margin-left: 20px;*/
  height: 137px;
  display: flex;

}

.mine-course-detail {
  position: relative;
  height: 108px;
  display: flex;
  flex-direction: column;
  border-bottom: 1px solid #d9dde1;
  padding-bottom: 28px;
  margin-left: 30px;
  font-size: 14px;
  line-height: 40px;
}

.mine-course-title {
  font-size: 20px;
  color: #07111b;
  font-weight: 700;
  line-height: 36px;
  text-decoration: none;
  max-width: 730px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

> > > .el-loading-mask {
  z-index: 900 !important;
}
</style>
